import React from 'react'
import { Route, IndexRedirect } from 'react-router'
import * as Views from './views'
import Layout from './layout'

const Routes = (
  <Route path="profile" component={Layout}>
    <IndexRedirect to="account" />
    <Route path="account" component={Views.Account} />
    <Route path="experience-skills" component={Views.ExperienceSkills} />
    <Route path="program-delivery" component={Views.ProgramDelivery} />
  </Route>
)

export default Routes
